export function formatDate(date: string | Date) {
  const d = typeof date === `string` ? new Date(date) : date;
  // const month = date.toLocaleString(`default`, { month: `short`, });

  return `${d.getUTCDate()}-${d.getUTCMonth() + 1}-${d.getUTCFullYear()}`;
}
